import { lazy } from 'react'

import Permessi from './permessi'

export default {
    path: '/ruoli',
    title: 'Ruoli',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:ruoloId',
            title: 'Ruolo: {{params.ruoloId}}',
            drawer: false,
            component: lazy(() => import('./detail')),
            pages: [Permessi]
        }
    ]
}